// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"876":"a639bfff","1398":"009d9706","3480":"4a081cb3","8267":"009d9706"}[chunkId] + ".chunk.css";
};